import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "m2.5 21.5 5.55-2.134c.354-.136.532-.205.698-.294q.221-.12.42-.273c.149-.116.283-.25.552-.519L21 7a2.828 2.828 0 1 0-4-4L5.72 14.28c-.269.269-.403.403-.519.552a3 3 0 0 0-.273.42c-.089.167-.157.344-.294.699zm0 0 2.058-5.35c.147-.384.221-.575.347-.663a.5.5 0 0 1 .38-.08c.15.029.295.174.585.464l2.26 2.259c.29.29.435.435.464.586a.5.5 0 0 1-.08.379c-.089.126-.28.2-.663.347z"
    }, null, -1)
  ])))
}
export default { render: render }